<template>
  <article
    v-if="incidence"
    :class="['collapsible-article', { active: element.expanded }]"
  >
    <header
      class="header background-gray"
      :class="incidence.severity"
      @click="element.expanded = !element.expanded"
    >
      <div
        class="article-icon has-text-centered is-size-1 has-text-grey"
        :class="incidence.severity"
      ></div>
      <div class="article-title pl-2 pr-1">
        <p>
          <span>{{ element.order_date | localize }}</span>

          <span v-if="incidence.status != 'closed'">
            <label
              v-if="incidence.severity == 'major_nonconformity'"
              :class="incidence.severity"
            >
              {{ $t("severities.high") }}
            </label>
            <label
              v-if="incidence.severity == 'minor_nonconformity'"
              :class="incidence.severity"
            >
              {{ $t("severities.medium") }}
            </label>
            <label
              v-if="incidence.severity == 'observation'"
              :class="incidence.severity"
            >
              {{ $t("severities.low") }}
            </label>
            <label
              v-if="incidence.severity == 'unimportant'"
              :class="incidence.severity"
            >
              {{ $t("severities.low") }}
            </label>
          </span>
          <span>
            <label class="messages" v-if="hasMessages && numberMessages > 0">
              <span>
                {{ numberMessages }}
                <img class="bell" src="@/assets/comment.png" />
              </span>
            </label>
          </span>
          <span v-if="incidence.status == 'closed'">
            <label :class="incidence.severity">{{ $t("severities.solved") }}</label>
          </span>
        </p>
        <p>
          <b>{{ $t("page.labels.parcel_incidence") }}</b>
        </p>
      </div>
      <div class="arrow"></div>
    </header>
    <div
      class="body article-body pa-2"
      :class="incidence.severity"
      v-if="element.expanded"
    >
      <div v-if="incidence.coordinator_description">
        <p v-if="incidence.source_visit">
          {{ $t("page.labels.our_visitor") }} {{ incidence.source_visit.visitor.name }}
          {{ $t("page.labels.visit_comment") }}:
        </p>
        <p v-if="!incidence.source_visit">
          {{ $t("page.labels.visit_comment_no_visitor") }}
        </p>
        <p>&nbsp;</p>
        <p>
          <b>{{ incidence.coordinator_description }}</b>
        </p>
        <p>&nbsp;</p>
      </div>

      <p>
        <b>{{ $t("page.labels.resolution_limit_date") }}:</b>
      </p>
      <p>{{ incidence.resolution_date_limit | localize }}</p>
      <p>&nbsp;</p>
      <span class="mt-2">{{ $t("page.labels.has_doubts") }}</span>
      <div class="my-2 columns is-mobile is-centered" v-if="!hasMessages">
        <router-link
          :to="{ name: 'incidence-open-enquiry', params: { id: incidence.id } }"
          class="button is-outlined back-white"
        >
          {{ $t("page.labels.write_to") }}
        </router-link>
      </div>
      <div class="my-2 columns is-mobile is-centered" v-if="hasMessages">
        <router-link
          :to="{
            name: 'enquiry-chat',
            params: { enquiryId: this.incidence.enquiry_set[0] },
          }"
          class="button is-outlined back-white"
        >
          {{ $t("page.labels.tracking") }}
          <span v-if="numberMessages > 0" class="ml-1">({{ numberMessages }})</span>
        </router-link>
      </div>
    </div>
  </article>
</template>
<script>
export default {
  name: "IncidenceCard",
  props: ["element"],
  data() {
    return {
      incidence: null,
      numberMessages: null,
      hasMessages: false,
    }
  },
  mounted() {
    this.getIncidence(this.element.entity)
    this.getComments(this.incidence.enquiry_set[0])
  },
  methods: {
    getIncidence(incidence) {
      this.$store.commit("setIncidence", incidence)
      this.incidence = this.$store.state.incidence
    },
    getComments(enquiryId) {
      if (!enquiryId) {
        return
      }

      this.$store.dispatch("loadComments", enquiryId).then(() => {
        this.numberMessages = this.$store.getters.getCountMessages
        this.hasMessages = this.$store.state.enquiryComments.length
      })
    },
  },
}
</script>
